// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Aerodrome } from './Aerodrome';
import { Coordinate } from './Coordinate';
import { PathPoint } from './PathPoint';
import { PathPointLoadClassification } from './PathPointLoadClassification';
import { Flight } from './Flight';

export class FlightPlan implements IFlightPlan {
    path!: PathPoint[];
    airspaces!: string[];

    constructor(data?: IFlightPlan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(PathPoint.fromJS(item));
            }
            if (Array.isArray(_data["airspaces"])) {
                this.airspaces = [] as any;
                for (let item of _data["airspaces"])
                    this.airspaces!.push(item);
            }
        }
    }

    static fromJS(data: any): FlightPlan {
        data = typeof data === 'object' ? data : {};
        let result = new FlightPlan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.airspaces)) {
            data["airspaces"] = [];
            for (let item of this.airspaces)
                data["airspaces"].push(item);
        }
        return data;
    }
}

export interface IFlightPlan {
    path: PathPoint[];
    airspaces: string[];
}